import { useQuery, useQueryClient } from '@tanstack/react-query';

import API_END_POINT from 'constants/apiEndPoints';
import fetchCurrentUser from 'api/user/fetchCurrentUser';

type UpdateUserValues = {
  [index: string]: any;
};

const queryKey = [API_END_POINT.USER.FETCH_CURRENT_USER];

const useUser = () => {
  const queryClient = useQueryClient();
  const userQueryData = useQuery({
    queryKey,
    queryFn: fetchCurrentUser,
    gcTime: Infinity,
    staleTime: Infinity,
  });

  const update = (values: UpdateUserValues) => {
    queryClient.setQueryData(queryKey, {
      ...userQueryData.data,
      ...values,
    });
  };

  return {
    ...userQueryData,
    update,
  };
};

export default useUser;
